'use strict';

$(() => {
    const DATA_CROPPING = '258f0f09-3243-4790-9cc6-cbc48e2df893';

    const croppingDragStart = function (event) {
        const $this = $(this);
        const $cont = $this.closest('.foto-container');
        const fs = Fotobook.book.getCurrentFontSize.call($cont);
        const bleed = fs * Fotobook.book.getClearSize(parseFloat($cont.attr('data-bleed')));
        const $img = $cont.find('.foto-image');
        const angle = Fotobook.angles.normalizeAngle(Fotobook.book.getContainerRealAngle($cont));
        const containerFotoAngle = Number($cont[0].style.getPropertyValue('--container-foto_angle')) || 0;
        const fotoOwnAngle = Number($img[0].style.getPropertyValue('--foto-angle')) || 0;
        const fotoAngle = Fotobook.angles.normalizeAngle(containerFotoAngle + fotoOwnAngle);
        const rotatedContSize = Fotobook.transforms.getRotatedBoundingBox(fotoAngle, $cont.width() + 2 * bleed, $cont.height() + 2 * bleed);
        const imageSize = {
            width: $img[0].width.animVal.value,
            height: $img[0].height.animVal.value,
        };
        const cx = Number($img.attr('data-crop_cx'));
        const cy = Number($img.attr('data-crop_cy'));
        const croppingData = {
            matrix: Fotobook.matrices.matrixCreateRotate(-(angle + fotoAngle)),
            image: $img,
            originalCx: cx,
            originalCy: cy,
            currentCx: cx,
            currentCy: cy,
            width: imageSize.width,
            height: imageSize.height,
            cropWidth: 100 * rotatedContSize.width / imageSize.width,
            cropHeight: 100 * rotatedContSize.height / imageSize.height,
            x: event.screenX,
            y: event.screenY,
        };
        $this.data(DATA_CROPPING, croppingData);
        Fotobook.book.backupInitialCoordinates($cont, ['cx', 'cy', 'crop_width', 'crop_height']);
        $('html').add($cont).add($cont.closest('.cont-wrapper')).addClass('crop-dragging');
    };

    const croppingDrag = function (event) {
        const $this = $(this);
        const croppingData = $this.data(DATA_CROPPING);
        if (!croppingData.width || !croppingData.height) {
            return;
        }
        const pos = croppingData.matrix.transform(event.screenX - croppingData.x, event.screenY - croppingData.y);
        const dx = pos.x / croppingData.width * 100;
        const dy = pos.y / croppingData.height * 100;

        const newUnboundedCx = croppingData.originalCx - dx;
        const newUnboundedCy = croppingData.originalCy - dy;

        const minCx = croppingData.cropWidth / 2;
        const minCy = croppingData.cropHeight / 2;
        const newCx = Fotobook.helpers.urange(minCx, newUnboundedCx, 100 - minCx);
        const newCy = Fotobook.helpers.urange(minCy, newUnboundedCy, 100 - minCy);
        croppingData.image.add(croppingData.image.siblings('.foto-image-cropping')).attr({
            x: `-${newCx}%`,
            y: `-${newCy}%`,
        });
        $this.data({
            [DATA_CROPPING]: {
                ...croppingData,
                currentCx: newCx,
                currentCy: newCy,
            },
        });
    };

    const croppingStop = function (event) {
        const $this = $(this);
        const $cont = $this.closest('.foto-container');
        const croppingData = $this.data(DATA_CROPPING);
        Fotobook.containers.changeContainerAttrs({
            [$cont.attr('data-id')]: {
                move_started: ($cont.data('fotobook-initial') || {}).time,
                crop_cx: croppingData.currentCx,
                crop_cy: croppingData.currentCy,
                crop_width: croppingData.cropWidth,
                crop_height: croppingData.cropHeight,
            },
        });
        $this.removeData(DATA_CROPPING);
        $('html').add($cont).add($cont.closest('.cont-wrapper')).removeClass('crop-dragging');
    };

    $(document).on('mouseover', '.foto-container .cropping-handle', function (e) {
        const $handle = $(this);
        const $cont = $handle.closest('.foto-container');

        $cont.closest('.cont-wrapper').addClass('crop-handle-over');
        if ($handle.is(':ui-draggable')) {
            return;
        }
        $handle.draggable({
            helper() {
                return $('<div><div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;"></div></div>');
            },
            appendTo: 'body',
            cursorAt: {
                left: 0,
                top: 0,
            },
            scroll: false,
            start: croppingDragStart,
            drag: croppingDrag,
            stop: croppingStop,
        });
    });
});
